<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Niveau Personnel " />
            <NiveauPersonnel />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'

import NiveauPersonnel from '../NiveauPersonnel/NiveauPersonnel.vue'


export default {
    name: 'NiveauPersonnelPage',
    components: {
        NavBar,
        PageTitle,
        NiveauPersonnel,
        FooterComp,
    }
}
</script>